import { parse } from "node-html-parser";
import visit from "unist-util-visit";
import { toHtml } from "hast-util-to-html";

export const getBlockProps = (props: Record<any, any>): any =>
  Object.entries(props)
    .map(([key, value]) => [key, JSON.parse(decodeURIComponent(value))])
    .reduce(
      (prev, [key, value]) => ({
        ...prev,
        [key]: value,
      }),
      {}
    );

export const preprocessContent = (content: string) => {
  const dom = parse(content);

  const elems = Array.from(dom.querySelectorAll("pre[data-block-type]"));

  elems.forEach((elem: any) => {
    const type = elem.getAttribute("data-block-type");

    try {
      const blockData = elem.childNodes[0].text.replace(/^<code>/, "").replace(/<\/code>$/, "");
      const data = JSON.parse(blockData);
      const attrs = Object.entries(data).reduce(
        (prev, [key, value]) => prev + ` ${key}="${encodeURIComponent(JSON.stringify(value))}"`,
        ""
      );
      const div = parse(`<div data-block-type="${type}" ${attrs}></div>`);

      elem.replaceWith(div);
    } catch (err) {}
  });

  return dom.toString().trim();
};

export const unwrapCustomParagraphs = (customTagNames: string[]) => {
  const customTags = new Set(customTagNames.map((tag) => tag.toLowerCase()));

  return function transformer(tree: any) {
    visit(tree, "element", (node: any, index: number | undefined, parent: any) => {
      if (!parent || index == null) return;
      if (node.tagName !== "p") return;
      if (!Array.isArray(node.children) || node.children.length === 0) return;

      const meaningfulChildren = node.children.filter((child: any) => {
        if (child.type === "text") {
          return child.value?.trim();
        }
        return true;
      });

      if (meaningfulChildren.length !== 1) return;

      const onlyChild = meaningfulChildren[0];

      if (
        onlyChild.type === "element" &&
        typeof onlyChild.tagName === "string" &&
        customTags.has(onlyChild.tagName.toLowerCase())
      ) {
        parent.children.splice(index, 1, onlyChild);
      }
    });
  };
};

export const removeTableStyles = (node: any) => {
  const tree = structuredClone(node);

  visit(tree, "element", (el: any) => {
    if (["table", "thead", "tbody", "tr", "th", "td"].includes(el.tagName)) {
      if (el.properties) {
        delete el.properties.style;
      }
    }
  });

  return toHtml(tree);
};

export const getOnlyElementsChildren = (val: Record<string, any>[]) =>
  val.filter(({ type }) => type === "element");

export const formatOl = (html: string) => {
  const dom = parse(html);
  const lis = Array.from(dom.querySelectorAll("> li, ol > li"));
  lis.forEach((li) => {
    const wrapper = parse("<div></div>").firstChild;

    if (!wrapper) return;

    const children = [...li.childNodes];

    children.forEach((child) => {
      // @ts-ignore
      wrapper.appendChild(child);
    });

    li.appendChild(wrapper);
  });

  return dom.toString();
};
